import constant from "../main.constants";

const entityManagementRoutes = [
    {
        path: "/fraud/entity-management/entities",
        name: "FraudEntities",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/Entity.vue"),
        },
        meta: {
            icon: "mdi-account",
            localize: "Varlıklar"
        }
    },
    {
        path: "/fraud/entity-management/attributes",
        name: "FraudAttributes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/Attribute.vue"),
        },
        meta: {
            icon: "mdi-lock",
            localize: "Attributes"
        }
    },
    {
        path: "/fraud/entity-management/parameterattributefilter",
        name: "FraudParameterAttributeFilter",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/ParameterAttributeFilter.vue"),
        },
        meta: {
            icon: "mdi-eye-outline",
            localize: "Özellik Filtreleri"
        }
    },
    {
        path: "/fraud/entity-management/datasources",
        name: "FraudDataSources",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/DataSource.vue"),
        },
        meta: {
            icon: "mdi-database",
            localize: "Veri Kaynakları"
        }
    },
    {
        path: "/fraud/entity-management/entityattributes",
        name: "FraudEntityAttributes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/EntitiesWithAttributes.vue"),
        },
        meta: {
            icon: "mdi-view-agenda-outline",
            localize: "Varlık Özellikleri"
        }
    },
    {
        path: "/fraud/entity-management/datatables",
        name: "FraudDataTables",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/EntityDatatable.vue"),
        },
        meta: {
            icon: "mdi-table",
            localize: "Varlık Veri Tabloları"
        }
    },
    {
        path: "/fraud/entity-management/attributemappings",
        name: "FraudAttributeMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/AttributeMappings.vue"),
        },
        meta: {
            icon: "mdi-arrow-left-right",
            localize: "Varlık Özellik İlişkileri"
        }
    },
    {
        path: "/fraud/entity-management/nodeedgemapping",
        name: "FraudNodeEdgeMapping",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/NodeEdgeMapping.vue"),
        },
        meta: {
            icon: "mdi-repeat",
            localize: "Varlık İlişkileri"
        }
    },
    {
        path: "/fraud/entity-management/entitymappings",
        name: "FraudEntityMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/EntityMappings.vue"),
        },
        meta: {
            icon: "mdi-arrow-collapse",
            localize: "Varlık İlişki Özellikleri"
        }
    },
    {
        path: "/fraud/entity-management/nodeedgemappingsdetails",
        name: "FraudNodeEdgeMappingsDetails",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/NodeEdgeMappingsDetails.vue"),
        },
        meta: {
            icon: "mdi-information-outline",
            localize: "Varlık İlişkileri Detayları"
        }
    },
    {
        path: "/fraud/entity-management/entityFilters",
        name: "FraudEntityFilters",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/EntityFilters.vue"),
        },
        meta: {
            icon: "mdi-checkbox-marked",
            localize: "Varlık Filtreleri"
        }
    },
    {
        path: "/fraud/entity-management/prepared-query-headers",
        name: "FraudPreparedQueryHeaders",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/PreparedQueryHeadersManagement.vue"),
        },
        meta: {
            icon: "mdi-check-network-outline",
            localize: "preparedQueryHeaders"
        }
    },
    {
        path: "/fraud/entity-management/clientSettings",
        name: "ClientSettings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/ClientSettings.vue"),
        },
        meta: {
            icon: "mdi-cog-box",
            localize: "clientSettings.menuName"
        }
    },
    {
        path: "/fraud/entity-management/userManagement",
        name: "UserManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/UserManagement.vue"),
        },
        meta: {
            icon: "mdi-account-edit",
            localize: "userManagement.toolbarTitle"
        }
    },
];

const permissionRoutes = [
    {
        path: "/fraud/authorization/usermanagement",
        name: "FraudUserManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/UserManagement.vue"),
        },
        meta: {
            icon: "mdi-account-group",
            localize: "Kullanıcı Yönetimi"
        }
    },
    {
        path: "/fraud/authorization/userroles",
        name: "FraudUserRoleManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/UserRoleManagement.vue"),
        },
        meta: {
            icon: "mdi-file-account",
            localize: "Kullanıcı Rol Yönetimi"
        }
    },
    {
        path: "/fraud/authorization/roles",
        name: "FraudRoleManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RoleManagement.vue"),
        },
        meta: {
            icon: "mdi-account-details",
            localize: "Rol Yönetimi"
        }
    },
    {
        path: "/fraud/authorization/rolepermissions",
        name: "FraudRolePermissionManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RolePermissionManagement.vue"),
        },
        meta: {
            icon: "mdi-account-check",
            localize: "Rol Yetki Yönetimi"
        }
    },
    {
        path: "/fraud/authorization/permissions",
        name: "FraudPermissionManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/PermissionManagement.vue"),
        },
        meta: {
            icon: "mdi-account-check-outline",
            localize: "Yetki Yönetimi"
        }
    },
];

const restActionRoutes = [
    {
        path: "/fraud/rest/actions",
        name: "FraudRestActions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RestServiceManagement.vue"),
        },
        meta: {
            icon: "mdi-api",
            localize: "fraud.menu.actions"
        },
        perm: constant.PERMISSIONS.actionManagement.actions
    },
    {
        path: "/fraud/rest/actionmappings",
        name: "FraudRestActionEntityMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RestServiceEntityMappings.vue"),
        },
        meta: {
            icon: "mdi-api",
            localize: "fraud.menu.actionEntityMappings"
        },
        perm: constant.PERMISSIONS.actionManagement.actionEntityMapping
    },
];

const investigationRoutes = [
    {
        path: "/fraud/investigation/detailed-investigation",
        name: "FraudDetailedInvestigation",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/DetailedInvestigation.vue"),
        },
        meta: {
            icon: "mdi-account-details-outline",
            localize: "fraud.menu.detailedInvestigation"
        },
        perm: constant.PERMISSIONS.complexQuery
    },
    {
        path: "/fraud/investigation/prepared-queries",
        name: "FraudPreparedQueries",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../components/prepared-query/PreparedQueryManagement.component.vue"),
        },
        meta: {
            icon: "mdi-text-box-check-outline",
            localize: "fraud.menu.preparedQueries"
        },
        perm: constant.PERMISSIONS.preparedQueryAdmin
    },
];

const preparedQueryRoutes = [
    {
        path: "/fraud/investigation/prepared-query/:id",
        name: "FraudPreparedQuery",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/PreparedQueryPage.vue"),
        },
        meta: {
            icon: "mdi-account-details-outline",
            localize: "fraud.menu.preparedQueries"
        },
        perm: constant.PERMISSIONS.preparedQuery
    },
    {
        path: "/fraud/investigation/prepared-query-edit/:preparedQueryId",
        name: "FraudPreparedQueryEdit",
        component: () => import("../views/fraud/DetailedInvestigation.vue"),
        meta: {},
        perm: constant.PERMISSIONS.preparedQueryAdmin
    },
];

const fraudManagementRoutes = [

    {
        path: "/fraud/management/response-types",
        name: "responseTypes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/ResponseType.vue"),
        },
        meta: {
            icon: "mdi-keyboard-return",
            localize: "fraud.menu.responseTypes"
        },
        perm: constant.PERMISSIONS.systemSettings.responseType
    },
    {
        path: "/fraud/management/ruleset-types",
        name: "ruleSetTypes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetType.vue"),
        },
        meta: {
            icon: "mdi-text-search-variant",
            localize: "fraud.menu.ruleSetTypes"
        },
        perm: constant.PERMISSIONS.systemSettings.ruleSetType
    },
    {
        path: "/fraud/serviceresponses",
        name: "FraudServiceResponse",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudServiceResponses.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.serviceResponses",
            isEntitySelectionEnabled: true
        },
        perm: constant.PERMISSIONS.systemSettings.serviceResponse
    },
    {
        path: "/fraud/management/service-response-transitions",
        name: "FraudServiceReponseTransition",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudServiceResponseTransition.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.serviceResponseTransitions",
            isEntitySelectionEnabled: true
        },
        perm: constant.PERMISSIONS.systemSettings.serviceResponseTransition
    },
    {
        path: "/fraud/management/incident-states",
        name: "FraudIncidentStates",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentStates.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.incidentStates",
        },
        perm: constant.PERMISSIONS.systemSettings.incidentState
    },
    {
        path: "/fraud/management/incident-state-transitions",
        name: "FraudIncidentStateTransitions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentStateTransition.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.incidentStateTransitions"
        },
        perm: constant.PERMISSIONS.systemSettings.incidentStateTransition
    },
    {
        path: "/fraud/management/case-states",
        name: "FraudCaseStates",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseStates.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.caseStates",
        },
        perm: constant.PERMISSIONS.systemSettings.caseState
    },
    {
        path: "/fraud/management/case-state-transitions",
        name: "FraudCaseStateTransitions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseStateTransition.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.caseStateTransitions"
        },
        perm: constant.PERMISSIONS.systemSettings.caseStateTransition
    },
];


export { entityManagementRoutes, permissionRoutes, restActionRoutes, investigationRoutes, preparedQueryRoutes, fraudManagementRoutes };

const routes = [
    {
        path: "/fraud/home",
        name: "FraudHome",
        component: () => import("../views/fraud/FraudHome.vue"),
        meta: {}
    },
    {
        path: "/fraud/incident-management",
        name: "IncidentManagements",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentManagement.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-calendar",
            localize: "fraud.incidents.title",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/rules/rule-candidate/:ruleCandidateId/:entityName",
        name: "ruleCandidate",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/fraud/rules/rule/:ruleId/:entityName",
        name: "rule",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/fraud/rules/ruleQuery/:serviceEntityName",
        name: "CreateRuleQuery",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/fraud/rules/approved",
        name: "ApprovedRules",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/ApprovedRules.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-magnify",
            localize: "fraud.menu.rules.activeRules",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/rules/waitings",
        name: "WaitingRules",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/WaitingRules.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-magnify",
            localize: "fraud.menu.rules.waitingRules",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/rules/history",
        name: "RuleHistory",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleHistory.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-history",
            localize: "fraud.menu.rules.history",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/rulesets",
        name: "ruleSets",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSet.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-text-search-variant",
            localize: "fraud.menu.ruleSets",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/ruleset-mappings",
        name: "RuleSetMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetMappings.vue"),
        },
        meta: {
            icon: "mdi-format-horizontal-align-center",
            localize: "fraud.menu.ruleSetMappings",
            isEntitySelectionEnabled: true
        },
    },
    {
        path: "/fraud/rulesetresponse",
        name: "RulesetResponse",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetResponse.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund-outline",
            localize: "fraud.menu.rulesetresponse",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/fraud/ruleQuery/:ruleId/:entityName",
        name: "RuleQuery",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/fraud/case-management/",
        name: "fraudCaseManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseGroup"),
        },
        meta: {
            icon: "mdi-briefcase-variant-outline",
            localize: "fraud.menu.caseGroupManagement"
        }
    },
    {
        path: "/fraud/case-management/details/:id",
        name: "CaseDetails",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseGroupDetail"),
        },
        meta: {
            icon: "mdi-account-details-outline",
            localize: "fraud.menu.caseGroupManagement"
        }
    },
    {
        path: "/fraud/incident/:incidentid/rule/:ruleid/evidence",
        name: "EvidenceDetail",
        component: () => import("../views/fraud/FraudEvidenceDetail"),
        meta: {
            localize: "fraud.menu.evidenceDetail",
            isFraudPage: true
        }
    },
    {
        path: "/fraud/incident/details/:id",
        name: "IncidentDetails",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentDetail"),
        },
        meta: {
            icon: "mdi-briefcase-variant-outline",
        }
    },
    ...fraudManagementRoutes,
    ...entityManagementRoutes,
    ...permissionRoutes,
    ...restActionRoutes,
    ...investigationRoutes,
    ...preparedQueryRoutes
];

for (const route of routes) {
    route.meta.layout = () => import("../components/layouts/FraudLayout.component.vue");
}

export default routes;